if (!window.Maximize.loadedScript.includes('pagination-search.js')) {
  window.Maximize.loadedScript.push('pagination-search.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xPaginationSearch", (sectionId) => ({
        loading: false,
        _autoLoadStreak: 0,
        _lastAutoLoadAt: 0,
        loadData(url, type, isPaginationType, isAutomatic) {
          if (isAutomatic) {
            const now = Date.now();
            this._autoLoadStreak = (now - this._lastAutoLoadAt < 3000) ? this._autoLoadStreak + 1 : 1;
            this._lastAutoLoadAt = now;
            if (this._autoLoadStreak > 5) {
              document.dispatchEvent(new CustomEvent('maximize:pagination-search:auto-load-capped', { detail: { type } }));
              return;
            }
          } else {
            this._autoLoadStreak = 0;
          }

          this.loading = true
          fetch(url)
          .then(response => response.text())
          .then(response => {
            const parser = new DOMParser();
            const html = parser.parseFromString(response,'text/html');
            const productGrid = html.getElementById(`ItemsGrid-${type}`);
            let productsOnPage = document.getElementById(`ItemsGrid-${type}`);
            if (productsOnPage && productGrid) {
              if (isPaginationType) {
                productsOnPage.innerHTML = productGrid.innerHTML;
              } else {
                const newProducts = productGrid.getElementsByClassName('grid-item');
                for (let i = 0; i < newProducts.length; i++) {
                  productsOnPage.insertAdjacentHTML('beforeend', newProducts[i].innerHTML);
                }
              }
              if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
              this._renderButton(html, type);
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            this.loading = false;
            if (isPaginationType) {
              document.querySelector(".main-search-form__wrapper").scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }
          })
        } ,
        _renderButton(html, type) {
          const destination = document.getElementById(`btn-pagination-${type}-${sectionId}`);
          const source = html.getElementById(`btn-pagination-${type}-${sectionId}`);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
          }
        }
      }));
    });
  });
}
